export default "__VITE_ASSET__Bh4bWffH__"